module.exports = __webpack_public_path__ + "static/image1-5090972455b72ce3ec7737b94bbd59ad.jpg";